<template>
    <div class="header">
        <div class="time">{{ currentTime | formatDate }}</div>
        <img class="logo" src="/img/svg/FeuchterStiftungLogo.svg">
    </div>
</template>
<style lang="scss">
    .header {
        background-color: $font-color;
        color: #FFFFFF;
        height: calc(max(5%, 60px));
        font-size: calc(max(2.8vh, 34px));
        font-family: 'RobotoMedium', sans-serif;
        padding-left: 3vw;
        padding-right: 5vw;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .logo {
        height: 80%;
    }    
</style>
<script>
    import moment from 'moment';
    export default {
        data() {
            return {
                currentTime: null,
            }
        },
        mounted() {
            setInterval(() => {
                this.currentTime = new Date();
            }, 1000);
        },
        filters: {
            formatDate(value) {
                if(value === null) {
                    return '';
                }
                return moment(value).locale('de').format(' HH:mm\xa0\xa0\xa0|\xa0\xa0\xa0dddd, DD.MM.YYYY ')
            }
        },     
    }
</script>
